import React from 'react';

// Reusable iOS-style toggle. Controlled: `on` + `onToggle` come from the parent.
const ToggleSwitch = ({ on, onToggle, id, disabled = false }) => (
  <button
    type="button"
    role="switch"
    aria-checked={on}
    onClick={onToggle}
    disabled={disabled}
    data-testid={id ? `toggle-${id}` : undefined}
    className={`relative inline-flex h-6 w-11 shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#4ABDBD]/40 ${
      on ? 'bg-[#4ABDBD]' : 'bg-gray-300'
    } ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
  >
    <span
      className={`pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ${
        on ? 'translate-x-5' : 'translate-x-0'
      }`}
    />
  </button>
);

export default ToggleSwitch;
